import { useState } from "react";
import { Container, Row, Col, Form, Button, ToastContainer, Alert } from "react-bootstrap";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";
import { GetDateNow, GetTimeNow } from "../../utils/DataUtils";
import toast from "react-hot-toast";
import { onlyDigits } from "../../services/valid";
import { StatusHse, DocumentosChips, corStatus } from "./statusHse";

export const Portaria = () => {
  const [peopleId, setPeopleId] = useState("");
  const [company, setCompany] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [editable, setEditable] = useState(false);
  const [document, setDocument] = useState("");
  const [badge, setBadge] = useState("");
  const [doc, setDoc] = useState("");
  const [obs, setObs] = useState("");
  const [service, setService] = useState("");
  const [local, setLocal] = useState("");
  const [responsible, setResponsible] = useState("");
  const [plate, setPlate] = useState("");
  const [sga, setSga] = useState(null);


  const locales = [
    "ADM", "ALMOXARIFADO", "AMBULATORIO", "AREA EXTERNA", "AREA TOTAL", "BRIGADA",
    "CAMPO", "COLETA", "CONTABILIDADE", "CONTROLADORIA", "COZINHA", "CT",
    "DEPOSITO VIDROS", "ENGENHARIA", "ESTACIONAMENTO", "ESTAMPARIA", "ESTAÇÃO AGUA",
    "EXPORTAÇAO", "FABRICA", "FERRAMENTARIA", "FINANCEIRO", "FISCAL", "FUNDOS AGP",
    "GAS", "IMPORTAÇAO", "JARDIM", "JURIDICO", "LABORATORIO", "LIMPEZA",
    "LOGISTICA", "MANUTENÇÃO", "MERCADO", "OBRA", "PASSAGEIROS", "PERICIA",
    "PORTARIA", "QUALIDADE", "RECEPÇÃO", "RESIDUO", "RH", "SALA LIMPA",
    "SEG TRABALHO", "SERVIÇOS", "TI", "TREINAMENTO", "USINAGEM"
  ];

  const limparCampos = () => {
    setPeopleId("");
    setCompany("");
    setName("");
    setPhone("");
    setEditable(false);
    setService("");
    setLocal("");
    setResponsible("");
    setPlate("");
    setObs("");
    setBadge("");
    setDoc("");
    setSga(null);
  };

  // Terceiro cadastrado no SGA/HSE: o back devolve status e motivos; 404 = visitante comum.
  const buscarStatusSga = async () => {
    try {
      const { data } = await blogFetch.get("/sga/collaborator/status", { params: { cpf: onlyDigits(document) } });
      return data;
    } catch (error) {
      return null;
    }
  };

  const buscarPessoa = async () => {

    if (!document.trim()) return;

    const terceiro = await buscarStatusSga();

    try {
      const { data } = await blogFetch.get(`/Entry/filter/${document}`);


      // Setar dados da pessoa
      setDocument(data.people.peA_cpf || "");
      setPeopleId(data.people.peA_PK_idPeople || "");
      setCompany(data.people.peA_company || "");
      setName(data.people.peA_Name || "");
      setPhone(data.people.peA_phone || "");

      // Setar dados da entrada
      setService(data.etR_typeService || "");
      setLocal(data.etR_local || "");
      setResponsible(data.etR_responsible || "");
      setPlate(data.etR_licensePlate || "");

      setEditable(true);

    } catch (error) {
      console.error("Erro ao buscar pessoa:", error);
      setEditable(false);
      setDocument(document)
      limparCampos();
    }

    setSga(terceiro);
    if (terceiro) {
      setName((atual) => atual || terceiro.nome);
      setCompany((atual) => atual || terceiro.empresa);
      setPhone((atual) => atual || terceiro.telefone || "");
    }
  };


  const salvarPessoa = async () => {
    const payload = {
      PEA_Name: name,
      PEA_cpf: document,
      PEA_phone: phone,
      PEA_company: company,
    };

    try {
      const { data } = await blogFetch.post("/people", payload);
      return data.peA_PK_idPeople;
    } catch (error) {
      return null;
    }
  };

  const salvarEntrada = async (id) => {

    const data = {
      ETR_FK_peopleId: id,
      ETR_licensePlate: plate,
      ETR_badge: badge,
      ETR_responsible: responsible,
      ETR_data: GetDateNow(),
      ETR_checkin: GetTimeNow(),
      ETR_typeService: service,
      ETR_local: local,
      ETR_doc: doc,
      ETR_obs: obs,
    };

    try {
      await blogFetch.post("/entry", data);
    } catch (error) {
    } finally {
      limparCampos();
    }
  };

  const handleSalvar = async () => {
    // Terceiro só entra com status Liberado; Pendente é tratado como bloqueado.
    if (sga && sga.status !== "Liberado") {
      toast.error(`Acesso negado: colaborador ${sga.status.toLowerCase()} no SGA.`);
      return;
    }

    if (!name || !document || !company) {
      toast.error("Preencha todos os campos obrigatórios!");
      return;
    }

    let id = peopleId;
    if (!editable) {
      id = await salvarPessoa();
      if (!id) {
        toast.error("Erro ao salvar os dados da pessoa.");
        return;
      }
    }

    try {
      await salvarEntrada(id);
      toast.success("Entrada cadastrada com sucesso!");
    } catch (error) {
      toast.error("Erro ao salvar entrada.");
    }
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <div className="app_body">
        <ToastContainer position="top-right" autoClose={3000} />
        <Container className="mt-6 justify-center">
          <div className="p-4 shadow-sm">
            <h3 className="text-center mb-4 fw-bold">Cadastro de Visitantes</h3>
            {sga && (
              <Alert
                variant={corStatus(sga.status)}
                className="mb-3 py-2 px-3 d-flex flex-wrap align-items-center gap-3"
              >
                <StatusHse status={sga.status} grande />
                <div className="lh-sm" style={{ fontSize: "0.95rem" }}>
                  <div>
                    <span className="fw-bold">{sga.nome}</span>
                    <span> · {sga.empresa} · {sga.funcao}{sga.matricula ? ` · ${sga.matricula}` : ""}</span>
                  </div>
                  {sga.motivos?.length > 0 && <div className="fw-semibold mt-1">{sga.motivos.join(" · ")}</div>}
                </div>
                <div className="ms-auto">
                  <DocumentosChips documentos={sga.documentos} />
                </div>
              </Alert>
            )}
            <Form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
                  e.preventDefault();
                }
              }}
            >
              <Row className="g-3">
                <Col md={4}>
                  <Form.Group className="d-flex gap-2">
                    <Form.Control
                      type="text"
                      placeholder="CPF/RG"
                      required
                      value={document}
                      onChange={(e) => {
                        setDocument(e.target.value);
                        setSga(null);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          buscarPessoa();
                        }
                      }}
                    />
                    <Button variant="outline-secondary" onClick={buscarPessoa}>
                      Buscar
                    </Button>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Nome"
                    value={name}
                    disabled={editable}
                    required
                    onChange={(e) => setName(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Telefone"
                    className={editable ? "bg-slate-400" : ""}
                    value={phone}
                    disabled={editable}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Empresa"
                    required
                    className={editable ? "bg-slate-400" : ""}
                    disabled={editable}
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Responsável"
                    value={responsible}
                    onChange={(e) => setResponsible(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Placa"
                    value={plate}
                    onChange={(e) => setPlate(e.target.value)}
                  />
                </Col>

                <Col md={4}>
                  <Form.Select value={local} onChange={(e) => setLocal(e.target.value)}>
                    <option value="">Local</option>
                    {locales.map((loc, i) => (
                      <option key={i} value={loc}>{loc}</option>
                    ))}
                  </Form.Select>
                </Col>

                <Col md={4}>
                  <Form.Select value={service} onChange={(e) => setService(e.target.value)}>
                    <option value="">Motivo</option>
                    <option value="Coleta">Coleta</option>
                    <option value="Entrega">Entrega</option>
                    <option value="Visita">Visita</option>
                    <option value="Serviço">Serviço</option>
                  </Form.Select>
                </Col>

                <Col md={4}>
                  <Form.Control
                    placeholder="Crachá"
                    value={badge}
                    onChange={(e) => setBadge(e.target.value)}
                  />
                </Col>

                <Col md={6}>
                  <Form.Control
                    placeholder="NF/Requisição"
                    value={doc}
                    onChange={(e) => setDoc(e.target.value)}
                  />
                </Col>

                <Col md={6}>
                  <Form.Control
                    placeholder="OBS"
                    value={obs}
                    onChange={(e) => setObs(e.target.value)}
                  />
                </Col>

                <Col xs={12} className="text-end mt-3">
                  <Button variant="primary" className="px-5" onClick={handleSalvar}>
                    Salvar
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Container>
      </div>
    </>
  );
};
